import { render, staticRenderFns } from "./GovernorRatio.vue?vue&type=template&id=ea523784"
import script from "./GovernorRatio.vue?vue&type=script&lang=js"
export * from "./GovernorRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports